import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { stepDirect } from "../actions/step";
// import { md5 } from "md5";
import { leadCall } from "../actions/lead";

import moment from "moment";

function formatTime(date) {
  let formattedDate = moment.utc(date).format("YYYYMMDDTHHmmssZ");
  return formattedDate.replace("+00:00", "Z");
}

function isMobile() {
  let mobile = false;

  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      mobile = true;
  })(window.navigator.userAgent || window.navigator.vendor || window.opera);

  return mobile;
}

function isBadIE() {
  let isCrappyIE = false;

  if (
    typeof window !== "undefined" &&
    window.navigator.msSaveOrOpenBlob &&
    window.Blob
  ) {
    isCrappyIE = true;
  }

  return isCrappyIE;
}

class ClassAppointment extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleCalendarIcs = this.handleCalendarIcs.bind(this);
    this.handleCalendarClick = this.handleCalendarClick.bind(this);
    this.generateProject = this.generateProject.bind(this);
    this.dataSort = this.dataSort.bind(this);
  }
  generateProject() {
    if (this.props.inquires.home.type === "demande") {
      if (this.props.inquires.demande.appointment === "telephone") {
        return 'Demande d\'information téléphonique';
      } else {
        return this.props.inquires.demande.test === "oui" ? "Demande d\'information chez mon distributeur avec essai" : "Demande d\'information chez mon distributeur sans essai";
      }
    } else {
      if (this.props.inquires.achat.test === "oui") {
        return 'Projet d\'achat chez mon distributeur avec essai';
      }else{
        if (this.props.inquires.achat.appointment === "telephone") {
          return 'Projet d\'achat téléphonique';
        } else {
          return 'Projet d\'achat chez mon distributeur sans essai';
        }
      }
    }
  }
  handleClick(index, url) {
    if(index!=6){
      this.props.stepDirect(index, url);
    } else {
      console.log(index)
      var url = "https://www.google.com/maps?q=" +
      this.props.restIntel.intel.dealerInfo.lat +
      "," +
      this.props.restIntel.intel.dealerInfo.lng;
      window.open(url);
    }
  }
  handleCalendarIcs(type) {
    let event = {
      title: "Rendez-vous SEAT",
      description: this.generateProject(),
      location: this.props.restIntel.intel.dealerInfo.street+", "+this.props.restIntel.intel.dealerInfo.zipCode+" "+this.props.restIntel.intel.dealerInfo.city,
      startTime: this.props.restIntel.intel.timeInfo.dayCalendar,
      endTime: this.props.restIntel.intel.timeInfo.dayCalendar
    };
    let calendarUrl = "";

    switch (type) {
      case "google":
        calendarUrl = "https://calendar.google.com/calendar/render";
        calendarUrl += "?action=TEMPLATE";
        calendarUrl += "&dates=" + formatTime(event.startTime);
        calendarUrl += "/" + formatTime(event.endTime);
        calendarUrl += "&location=" + encodeURIComponent(event.location);
        calendarUrl += "&text=" + encodeURIComponent(event.title);
        calendarUrl += "&details=" + encodeURIComponent(event.description);
        break;

      default:
        calendarUrl = [
          "BEGIN:VCALENDAR",
          "VERSION:2.0",
          "BEGIN:VEVENT",
          "URL:" + document.URL,
          "DTSTART:" + formatTime(event.startTime),
          "DTEND:" + formatTime(event.endTime),
          "SUMMARY:" + event.title,
          "DESCRIPTION:" + event.description,
          "LOCATION:" + event.location,
          "END:VEVENT",
          "END:VCALENDAR"
        ].join("\n");

        if (!isBadIE() && isMobile()) {
          calendarUrl = encodeURI(
            "data:text/calendar;charset=utf8," + calendarUrl
          );
        }
    }

    return calendarUrl;
  }
  handleCalendarClick(e, target) {
    e.preventDefault();
    let url = e.currentTarget.getAttribute("href");

    if (!isMobile() && (url.startsWith("data") || url.startsWith("BEGIN"))) {
      let filename = "download.ics";
      let blob = new Blob([url], { type: "text/calendar;charset=utf-8" });
      if (isBadIE()) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      window.open(url, "_blank");
    }
    //TRACKING
    var values = {};
    var type = this.props.inquires.home.type;
    values.eventName = "confirmation";
    console.log(this.props.inquires[type]['financing'], this.props.inquires[type]['customerSeat']);

    if(this.props.inquires.home.type=="achat") {
      this.props.inquires[type]['purchaseTime']['leadName']===undefined ? values['purchaseIntent'] = "Less than a month" : values['purchaseIntent'] = this.props.inquires[type]['purchaseTime']['leadName'];
    } else {
      values['purchaseIntent']="";
    }
    this.props.inquires[type]['financing']===undefined ? values['financinge'] = "non" : values['financinge'] = this.props.inquires[type]['financing'];
    this.props.inquires[type]['customerSeat']===undefined ? values['seatCustomer'] = "non" : values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
    values['licenseRegistration'] = "";
    this.props.inquires[type]['test']=="non" || this.props.inquires[type]['test']==null ? values['testDrive'] = "non" : values['testDrive'] = "oui";
    values.modelChoice = this.props.restIntel.intel.dealerInfo.idCar;
    values.dealerChoice = this.props.restIntel.intel.dealerInfo.proFullName;
    values.postalCode = this.props.restIntel.intel.dealerInfo.zipCode;
    values.dateChoice = this.props.restIntel.intel.timeInfo.dayCalendar;
    values.time = this.props.restIntel.intel.timeInfo.time;
    values.calendarChoice = target;
    var iframeData = ["setData", values];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
    console.log(values);
  }
  componentDidMount() {
    if(this.props.lead.idLead!=null){
      var md5 = require('md5');
      let appname = "erdv";
      let sec_key = md5(this.props.lead.idLead+appname+"c9q=L&P9[7Bi");
      var gender = this.props.inquires.user.civility === 'Madame' ? 'mme' : 'mr';
      var datearr = this.props.restIntel.intel.timeInfo.dayCalendar.split('T');
      var date = datearr[0];
      var hours = datearr[1].split('+');
      hours = hours[0];
      var dateerd = moment(this.props.restIntel.intel.timeInfo.dayCalendar).format('YYYY-MM-DD hh:mm:ss');

      // var adrs= this.props.inquires.user.address.split(' ');
      // console.log(adrs);

      let dataCall = {
        app_name : appname,
        secure_key : sec_key,
        lead_id : this.props.lead.idLead,
        proID : this.props.restIntel.intel.dealerInfo.id,
        proName : this.props.restIntel.intel.dealerInfo.proFullName,
        date_eRdv : date+" "+hours,
        reference : this.props.restIntel.intel.appointment.reference,
        action : 'update',
        isERDV : 1,
        state : 'a_traiter'
      };
      if(this.props.inquires.user.optin==="oui"){
        dataCall.privacy_email = "G";
      } else if(this.props.inquires.user.optin==="non"){
        dataCall.privacy_email = "F";
      } else  {
        dataCall.privacy_email = "U";
      }
      let dataCallMerge = {...this.dataSort(), ...dataCall};
      this.props.leadCall(dataCallMerge,'leads-update');


      //TRACKING
      var values = {};
      var type = this.props.inquires.home.type;
      values.eventName = "confirmation";
      if(this.props.inquires.home.type=="achat") {
        this.props.inquires[type]['purchaseTime']['leadName']===undefined ? values['purchaseIntent'] = "Less than a month" : values['purchaseIntent'] = this.props.inquires[type]['purchaseTime']['leadName'];
      
      //TRACKING SMART SIGNAL 

var CarInfo = this.props.restIntel.intel.dealerInfo.idCar;
(window.smartSignals2 = window.smartSignals2 || []).push({
  event: 'FormSubmissionTestDrive',
  payload: {           
    leadInformation: {
               version: '1.0',
               leadType: '1',
productName: CarInfo }
}
});

      } else if (this.props.inquires.home.type=="demande") {

      //TRACKING SMART SIGNAL 

var CarInfo = this.props.restIntel.intel.dealerInfo.idCar;
(window.smartSignals2 = window.smartSignals2 || []).push({
  event: 'FormSubmissionContactRequest',
  payload: {           
    leadInformation: {
               version: '1.0',
               leadType: '3',
productName: CarInfo }
}
});

        values['purchaseIntent']="";

      }
      this.props.inquires[type]['financing']===undefined ? values['financinge'] = "non" : values['financinge'] = this.props.inquires[type]['financing'];
      this.props.inquires[type]['customerSeat']===undefined ? values['seatCustomer'] = "non" : values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
      values['licenseRegistration'] = "";
      this.props.inquires[type]['test']=="non" || this.props.inquires[type]['test']==null ? values['testDrive'] = "non" : values['testDrive'] = "oui";
      values.modelChoice = this.props.restIntel.intel.dealerInfo.idCar;
      values.dealerChoice = this.props.restIntel.intel.dealerInfo.proFullName;
      values.postalCode = this.props.restIntel.intel.dealerInfo.zipCode;
      values.dateChoice = this.props.restIntel.intel.timeInfo.dayCalendar;
      values.time = this.props.restIntel.intel.timeInfo.time;
      values.calendarChoice = "";
      var iframeData = ["setData", values];
      window.top.postMessage(iframeData , '*');
      console.log(values);

     
    } else {
      var iframeData = ['setVirtualPage', 'rdv-en-ligne/confirmation'];
      console.log('iframeData :'+ iframeData );
      window.top.postMessage(iframeData , '*');
      //Tracking le premier lead n'as pas ete appellé
    }

  }

  dataSort(){
      let type_of = this.props.inquires.home.type;
      let request_type = {};
      let commentArray = {
        type : type_of
      };

      // trial = this.props.inquires.type_of.test,
      if(type_of==="achat"){
        request_type.type_financement = this.props.inquires[type_of].financing;
        request_type.purchase_intention = this.props.inquires[type_of].purchaseTime.leadName;

        commentArray['test'] = this.props.inquires[type_of].test;
        if(commentArray['test']==="non"){
          commentArray['appointment'] = this.props.inquires[type_of].appointment;
        }
        commentArray['customerSeat'] = this.props.inquires[type_of].customerSeat;
        if(commentArray['customerSeat']==="oui"){
          commentArray['plate'] = this.props.inquires[type_of].plate;
        }
      } else if (this.props.inquires.home.type==="demande"){

        commentArray['appointment'] = this.props.inquires[type_of].appointment;
        if(commentArray['appointment']==="concession"){
          commentArray['test'] = this.props.inquires[type_of].test;
        }
        commentArray['comment'] = this.props.inquires[type_of].comment;
      }
      request_type.comment = JSON.stringify(commentArray);
      return request_type;
  }

  render() {
    return (
      <div className="moduleMainBodyIntel">
        <div className="pageFormTitle fontBold colorBlack">
          Votre rendez-vous a été confirmé. Un email de confirmation vient de vous être envoyé.
        </div>
        <div className="pageDateTxt colorBlack fontExtraLight">
          {this.props.restIntel.intel.timeInfo.dayLet +
            " " +
            this.props.restIntel.intel.timeInfo.dayNum}
          <span>
            {" " + this.props.restIntel.intel.timeInfo.month}
          </span>{" "}
          {" " + this.props.restIntel.intel.timeInfo.time}
        </div>
        <div className="pageFormTitle fontBold colorBlack">
          Ajouter mon rendez-vous à mon calendrier
        </div>
        <div className="pageCtaRdvContent">
          <a
            onClick={e => this.handleCalendarClick(e, 'apple')}
            href={this.handleCalendarIcs("ics")}
            target="_blank"
          >
            <div className="pageRdvCta ctaPictoCalendar ctaGrey fontMedium colorBlack">
              <div className="iconCta pictocta_Apple" />
              <div className="txtCta">Apple</div>
            </div>
          </a>
          <a
            onClick={e => this.handleCalendarClick(e, 'google')}
            href={this.handleCalendarIcs("google")}
            target="_blank"
          >
            <div className="pageRdvCta ctaGrey fontMedium colorBlack">
              <div className="iconCta pictocta_Google" />
              <div className="txtCta">Google</div>
            </div>
          </a>
          <a
            onClick={e => this.handleCalendarClick(e, 'window')}
            href={this.handleCalendarIcs("ics")}
            target="_blank"
          >
            <div className="pageRdvCta ctaGrey fontMedium colorBlack">
              <div className="iconCta pictocta_Windows" />
              <div className="txtCta">Windows</div>
            </div>
          </a>
        </div>
        <div className="pageCtaRdvContent pageCtaRdvContentBottom">
          <div
            className="pageRdvCta ctaRed fontMedium colorBlack"
            onClick={e => this.handleClick(0, "/")}
          >
            <div className="txtCta">Retour à l’accueil</div>
          </div>
          <div className="pageRdvCta ggle-cta ctaGrey fontMedium colorBlack" onClick={e => this.handleClick(6, "/Module")}>
            <div className="iconCta pictocta_Maps" />
            <div className="txtCta">Ouvrir la carte</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      stepDirect,
      leadCall
    },
    dispatch
  );

export const PageAppointment = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassAppointment);



// WEBPACK FOOTER //
// ./src/containers/PageAppointment.js